import {LogLevel, Platform} from "@variocube/app-api";
import {logger} from "./logger";

const log = logger.sub("AUDIT");

export async function auditLog(platform: Platform, type: "Store" | "Pickup" | "Maintenance", data?: {}) {
    log.info(type, data);
    return await platform.log(LogLevel.Audit, type, data);
}